import { render, staticRenderFns } from "./extension-status.vue?vue&type=template&id=36e43c96"
import script from "./extension-status.vue?vue&type=script&lang=js"
export * from "./extension-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports